<template>
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 2v6a2 2 0 1 1-4 0V2M5 8v14M16 2c-1.7 0-3 2.7-3 6s1.3 6 3 6M16 2v20" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
